import React, { useState } from 'react';
import ButtonHeaderUI from '../HeaderButton';
import setting_icon from '../../icons/setting.svg';
import { Popover } from 'antd';
import ButtonSettingPopoverContent from './components/ButtonSettingPopoverContent';
import PermissionManager from 'widgets/PermissionVerify';

const ButtonSetting = () => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = async (newOpen: boolean) => {
    if (newOpen) {
      const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.APPOINTMENT_SETTING);
      if (!result || result?.skip) return setOpen(newOpen);
      if (!result.verifyData) return;
    }

    setOpen(newOpen);
  };

  return (
    <Popover
      placement='bottom'
      overlayInnerStyle={{ padding: 0 }}
      content={<ButtonSettingPopoverContent onHide={() => setOpen(false)} />}
      title={null}
      trigger='click'
      open={open}
      onOpenChange={handleOpenChange}
    >
      <ButtonHeaderUI title={'Setting'} src={setting_icon} alt={'setting_icon'} />
    </Popover>
  );
};

export default ButtonSetting;
